import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-bodhraj',
  templateUrl: './bodhraj.component.html',
  styleUrls: ['./bodhraj.component.scss']
})
export class BodhrajComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getBodhraj();
  }

}
